<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyTabLinks />
                    <SurveyCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/surveys`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyTabLinks from '@/components/surveys/SurveyTabLinks';
    import SurveyCard from '@/components/surveys/SurveyCard';

    export default {
        name: 'Survey',

        components: {
            SurveyTabLinks,
            SurveyCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/surveys/${id}`)).data;
            },
        },
    };
</script>
